import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import { NudgesRs } from '@domain/rs/NudgeRs';

const nudgesPrefix = '/nudges';

export default interface NudgesRepo {
  //넛지 리스트 조회
  fetchNudges(): Promise<AxiosResponse<NudgesRs>>;
}

export class RemoteNudgesRepo implements NudgesRepo {
  fetchNudges() {
    return axios.get<NudgesRs>(`${nudgesPrefix}`);
  }
}
